import { Tipo_solicitud } from './../../../models/tipo_solicitud.model';
import { Component, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent, MatAutocompleteSelectedEvent } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';
import { getDocuments } from 'src/app/services/getDocuments.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export interface Solicitud {
    optradio: string;
}

@Component({
    selector: "page-tipo_solicitud",
    templateUrl: "./tipo_solicitud.component.html",
    styleUrls: ["./tipo_solicitud.component.css"]

})


export class Tipo_solicitudComponent {


    @ViewChild('fruitInput') fruitInput: ElementRef;

    public generico = GLOBAL.generico;
    public rows = [];
    public actualRow;
    public tipo_solicitud: Tipo_solicitud;
    public tipo_sol = new FormControl('');
    public form;
    public formchecks;
    public solicitud = { "AMPLIACIÓN MENOR A 100 M2": false, "MODIFICACIÓN": false, "ART 6 2 9 OGUC": false }
    public solicitud2 = { "": false }

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    separatorKeysCodes = [ENTER, COMMA];

    fruitCtrl = new FormControl();

    filteredFruits: Observable<any[]>;
    materias: string[] = [];
    /*   readonly separatorKeysCodes: number[] = [ENTER]; */
    sols: Solicitud[] = [];
    formulario
    doc
    tipoSolDoc = []
    fruits = [
        'Lemon',
    ];
    allFruits = [

    ];
    checked = []
    sinTipo = false


    constructor(
        private fb: FormBuilder,
        private _docs: getDocuments,
        private cd: ChangeDetectorRef,
    ) {

        console.log("generico en tipo ", this.generico);

        if (!JSON.parse(localStorage.getItem("tipo_solicitud"))) {
            localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("tipo_solicitud"));
            /*  this.solicitud = {
                 "AMPLIACIÓN MENOR A 100 M2": 'SI' ? this.rows[0].optradio["AMPLIACIÓN MENOR A 100 M2"] : 'NO',
                 "MODIFICACIÓN": 'SI' ? this.rows[0].optradio["MODIFICACIÓN"] : 'NO',
                 "ART 6 2 9 OGUC": 'SI' ? this.rows[0].optradio["ART 6 2 9 OGUC"] : 'NO'
 
 
 
             } */
        }


        this.formchecks = new FormGroup({
            solicitud1: new FormControl(''),
            solicitud2: new FormControl(''),
            solicitud3: new FormControl('')
        })

        if (!JSON.parse(localStorage.getItem("tipo_solicitud"))) {
            /* console.log('nuevo') */
            this.rows = [{
                optradio: this.solicitud
            }]
            /*  console.log('nuevo this.rows', this.rows); */
            localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));

        } else {
            /*   console.log('desde borrador'); */
            this.rows = JSON.parse(localStorage.getItem("tipo_solicitud"));
            this.formchecks.controls['solicitud1'].setValue(this.rows[0] /*existe*/ ? this.rows[0].optradio["AMPLIACIÓN MENOR A 100 M2"] : false);
            this.formchecks.controls['solicitud2'].setValue(this.rows[0] ? this.rows[0].optradio["MODIFICACIÓN"] : false);
            this.formchecks.controls['solicitud3'].setValue(this.rows[0] ? this.rows[0].optradio["ART 6 2 9 OGUC"] : false);
        }
        /*  } else{
             console.log(JSON.parse(localStorage.getItem("tipo_sol")));
 
             if (JSON.parse(localStorage.getItem("tipo_sol"))) {
                 console.log('desde borrador');
                 this.sols = JSON.parse(localStorage.getItem("tipo_sol"));
                
             }
         } */
        this.formulario = localStorage.getItem("formId");
        if (this.formulario != '') {
            this.tipoSolData()

        }

        this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
            startWith(null),
            map((fruit: string | null) => fruit ? this.filter(fruit) : this.allFruits.slice()));

    }

    ngOnInit() {
        this.form = localStorage.getItem('form');
        if (!this.generico) {

            //this.formulario = localStorage.getItem("form");
            this.formulario = "1.1"
            /* console.log(this.sinTipo) */
        }
    }

    ngAfterViewChecked() {
        var sol = localStorage.getItem("formIdOK");

        if (sol == "cambiado") {
            localStorage.setItem("formIdOK", "listo")
            console.log("tipo sol, SOL ", sol)

            var x = localStorage.getItem("formId");

            console.log("Formulario, SOL ", this.formulario)
            if (this.formulario != x) {
                this.formulario = localStorage.getItem("formId");
                this.tipoSolData()
                console.log("formId, a cambiado")
            }

        }



    }



    filter(name: string) {
        return this.allFruits.filter(fruit =>
            fruit.toLowerCase().indexOf(name.toLowerCase()) === 0);
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        this.fruits.push(event.option.viewValue);
        this.fruitInput.nativeElement.value = '';
        this.fruitCtrl.setValue(null);
    }

    tipoSolData() {
        this._docs.getDocs().subscribe(
            data => {
                this.doc = data;
                console.log("JSON", data)
                console.log("this.formulario", this.formulario)
                this.tipoSolDoc = []

                for (let index = 0; index < this.doc.length; index++) {

                    if (this.doc[index].Cod == this.formulario) {
                        console.log(this.doc[index])
                        this.doc = this.doc[index];


                        for (let i = 0; i < this.doc.Materias.length; i++) {
                            console.log("JSON", this.doc)

                            this.tipoSolDoc.push({ tipo: this.doc.Materias[i].Nombre })

                        }
                    }
                }

                this.materias = this.tipoSolDoc
                console.log("tipoSolDoc", this.tipoSolDoc)
                if (this.tipoSolDoc) {
                    if (this.tipoSolDoc[0].tipo == "N/A") {
                        /*    console.log(this.tipoSolDoc)
                           console.log(this.sinTipo) */
                        this.sinTipo = true
                        var tipo = []
                        tipo.push("N/A")
                        localStorage.setItem("tipo_sol", JSON.stringify(tipo));
                        localStorage.setItem("tipo_solOK", "cambiado");
                    }
                }
                /*  console.log("Tipo de solicitudes: ", this.tipoSolDoc) */

                /*   let sinRepetidos = this.tipoSolDoc.filter((valorActual, indiceActual, arreglo) => {
                      return arreglo.findIndex(valorDelArreglo => JSON.stringify(valorDelArreglo) === JSON.stringify(valorActual)) === indiceActual
                  });
  
                  this.allFruits = sinRepetidos
                  this.cd.detectChanges();
                  console.log("Sin repetidos es:", sinRepetidos); */

            },
            error => {
                console.log(error)
            })
    }



    add_tipo_sol(tipoSol) {
        /*  console.log('Value', tipoSol) */
        localStorage.setItem("tipo_solicitud", tipoSol);
        /*  console.log('Storage', localStorage.getItem("tipo_solicitud")); */
    }

    /*    add_tipo_solicitud() {
   
           localStorage.setItem("tipo_solicitud", JSON.stringify([]));
           this.actualRow = localStorage.getItem("tipo_solicitud");
           this.rows = JSON.parse(this.actualRow);
           this.rows = this.rows.concat({
               optradio: this.solicitud
   
   
           })
           console.log(this.rows);
   
           localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));
           console.log(JSON.parse(localStorage.getItem("tipo_solicitud")));
   
       } */

    add_tipo_solicitud() {
        this.solicitud = {
            "AMPLIACIÓN MENOR A 100 M2": this.formchecks.value.solicitud1,
            "MODIFICACIÓN": this.formchecks.value.solicitud2,
            "ART 6 2 9 OGUC": this.formchecks.value.solicitud3,
        }
        this.rows = [{
            optradio: this.solicitud
        }]
        localStorage.setItem("tipo_solicitudOK", "cambiado")
        /* console.log('add_tipo_solicitud this.rows', this.rows); */
        localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));
    }

    delete_tipo_solicitud(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));
            }
        }
    }


    /*     add(event: MatChipInputEvent): void {
            const input = event.input;
            const value = event.value;
            localStorage.setItem("tipo_sol", JSON.stringify([]));
            // Add our fruit
            if ((value || '').trim()) {
                this.sols.push({
                    optradio: value.trim()
                });
            }
    
            console.log(this.sols)
            localStorage.setItem("tipo_sol", JSON.stringify(this.sols));
            console.log(JSON.parse(localStorage.getItem("tipo_sol")));
            // Reset the input value
            if (input) {
                input.value = '';
            }
        }
    
        remove(sols: Solicitud): void {
            localStorage.setItem("tipo_sol", JSON.stringify([]));
            const index = this.sols.indexOf(sols);
    
            if (index >= 0) {
                this.sols.splice(index, 1);
            }
    
            localStorage.setItem("tipo_sol", JSON.stringify(this.sols));
            console.log(JSON.parse(localStorage.getItem("tipo_sol")));
        } */


    onChange(event, shoe) {

        console.log(event)
        console.log(shoe)
        this.checked.push(shoe.tipo)


        console.log('on ng model change', event);
        localStorage.setItem("tipo_sol", JSON.stringify(event));
        localStorage.setItem("tipo_solOK", "cambiado");
    }

    onNgModelChange(event) {
        console.log('on ng model change', event);
        localStorage.setItem("tipo_sol", JSON.stringify(event));
        localStorage.setItem("tipo_solOK", "cambiado");
    }
}

